import LegalPage from "@/pages/legal/LegalPage";

export default function Disclaimer() {
  return (
    <LegalPage
      testid="disclaimer-page"
      draft
      title="Disclaimer"
      updated="2026-06-01"
      intro="Please read this alongside our Terms & Conditions. It sets out the limits of what Trifit.XPS outputs mean."
      sections={[
        { h: "Not medical advice", p: [
          "Trifit.XPS is a coaching decision-support platform. It is not a medical device and it does not diagnose, treat, cure or prevent any condition. Injury risk is a probability estimate produced by a model, not a diagnosis.",
          "Medical, physiotherapy and return-to-play decisions must be made by qualified clinicians. Where the platform flags a risk, treat it as a prompt to seek professional judgement.",
        ]},
        { h: "Model estimates, not guarantees", p: [
          "Readiness, sharpness, effort, rest, priority, simulated projections and every other computed figure are estimates derived from the data available. Accuracy depends on data completeness and quality.",
          "We do not claim clinical validation, causal explanation, or a specific accuracy percentage. Where the data behind a figure is insufficient, the platform withholds the figure rather than guessing.",
          "Simulated future states show modelled uncertainty. They are planning aids, not predictions of what will happen.",
        ]},
        { h: "Wearables and third-party data", p: [
          "Device and app data is supplied by third parties and reaches us on their schedule. Values can be revised, delayed or incomplete. Freshness is always shown so you know how current a figure is.",
        ]},
        { h: "Your responsibility", p: [
          "You remain responsible for the training, nutrition, medical and selection decisions you take. Coaches must apply their own professional judgement and their organisation's protocols.",
        ]},
      ]}
    />
  );
}
